import * as React from 'react';
import { Testimonials } from './testimonials';
export function ServiceItemContent(props) {
    if (!props.parentRect || !props.itemToggled) {
        return null;
    }
    var _a = React.useState(0), topPos = _a[0], setTopPos = _a[1];
    var staticTopLoss = 20;
    var item = props.item;
    var container = React.useRef(null);
    React.useEffect(function () {
        setTopPos(props.scrollY + props.parentRect.height + props.parentRect.top - staticTopLoss);
    }, []);
    React.useLayoutEffect(function () {
        if (container.current) {
            props.setParentMargin(container.current.clientHeight);
        }
        return function () {
            setTopPos(0);
            props.setParentMargin(staticTopLoss);
        };
    }, [container]);
    return (React.createElement("div", { ref: container, className: 'page-item-extra-content element-flex', style: { top: topPos } },
        React.createElement("div", { className: 'page-item-extra-content-image element-flex', style: { backgroundImage: "url('".concat(item.imgPath, "')") } }, !item.imgPath && React.createElement("i", { className: 'fa-regular fa-cog' })),
        React.createElement("div", { className: 'page-item-extra-content-info' },
            item.htmlContent &&
                React.createElement("div", { className: 'free-text', dangerouslySetInnerHTML: { __html: item.htmlContent } }),
            item.testimonials && item.testimonials.length > 0 &&
                React.createElement(Testimonials, { items: item.testimonials }),
            item.buttonLabel && item.buttonUrl &&
                React.createElement("div", { className: 'empori-buttons-container align-center' },
                    React.createElement("a", { href: item.buttonUrl, className: "empori-button p-c-bgc" }, item.buttonLabel)),
            React.createElement("div", { className: 'close-container' },
                React.createElement("a", { className: 'empori-button p-c-bgc text-like', onClick: props.closeItem },
                    item.closeLabel,
                    React.createElement("i", { className: 'fa-regular fa-times' }))))));
}
